import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import CommunityHighlight from './components/CommunityHighlight';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="WebPage" data={{
        name: '老色哥 - 成熟男士穿搭风格指南 | 老色哥潮流社区',
        description: '老色哥是专为成熟男性打造的穿搭风格与生活美学平台，汇聚老色哥社区达人分享经典绅士穿搭、复古时尚搭配技巧，帮助中年男性找回自信魅力，展现成熟男人独特品味与格调。',
        url: 'https://www.laosege.com/',
      }} />

      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <CommunityHighlight />
        <NewsletterSection />
      </main>
    </>
  );
}